function removeActiveFilterOnTop() {
    const current_page_url = new URL(window.location.href);
    const productTypes = current_page_url.searchParams?.getAll("filter.p.product_type");
    const productTheme = current_page_url.searchParams?.getAll("filter.p.m.custom.theme");

    if (productTypes?.length > 1 || productTheme?.length > 1) {
        document?.querySelectorAll('.clickable-content').forEach(link => {
            link?.setAttribute("data-active", "false");
        });
    }
}
document.addEventListener("DOMContentLoaded", function () {
    document.querySelector("button.apply-filter-button")?.addEventListener("click", function () {
        removeActiveFilterOnTop();
    });
    const urlParamsFromLanding = new URLSearchParams(window.location.search);
    const fromLandingPage = urlParamsFromLanding.get('from_landing_page');
    document.querySelectorAll('.tag--remove a').forEach(link => {
        if (fromLandingPage) {
            const url = new URL(link.href);
            url.searchParams.set('from_landing_page', fromLandingPage);
            link.href = url.toString();
        }
    });
    let wrapper;
    if (fromLandingPage) {
        wrapper = document.querySelector(`.image-title-section.${fromLandingPage}`);
        if (wrapper) {
            wrapper.style.display = "flex"; // or "block"
        }
    } else {
        wrapper = document.querySelector('.image-title-section');
        if (wrapper) {
            wrapper.style.display = "none";
        }
    }
    const urlParams = new URLSearchParams(window.location.search);
    const productfilter = fromLandingPage === "shop_by_theme"
        ? urlParams.get("filter.p.m.custom.theme")
        : urlParams.get("filter.p.product_type");

    // Select all clickable blocks
    const clickableBlocks = document.querySelectorAll(".clickable-content");

    clickableBlocks.forEach(block => {
        const title = block.dataset.title;
        if (title === productfilter) {
            block.dataset.active = "true";
            block.classList.add("active");
        } else {
            block.dataset.active = "false";
            block.classList.remove("active");
        }
        block.addEventListener('click', function () {
            const isActive = this.dataset.active === "true";
            const filterName = this.dataset.title;
            const isDesktop = window.matchMedia("(min-width: 769px)").matches;

            if (!isDesktop) {
                const url = new URL(window.location.href);

                if (filterName === "View all") {
                    url.searchParams.delete("filter.p.product_type");
                    url.searchParams.delete("filter.p.m.custom.theme");
                } else {
                    if (fromLandingPage === "shop_by_theme") {
                        url.searchParams.set("filter.p.m.custom.theme", filterName);
                        url.searchParams.delete("filter.p.product_type");
                    } else {
                        url.searchParams.set("filter.p.product_type", filterName);
                        url.searchParams.delete("filter.p.m.custom.theme");
                    }
                }

                window.history.replaceState({}, '', url.toString());
            }


            const filterDrawer = document.getElementById("FilterDrawer");
            const applyFilterBtn = filterDrawer.querySelector("button.apply-filter-button");

            // Ensure sideBarFilterByBtn is defined before using it
            let sideBarFilterByBtn;
            if (fromLandingPage == "shop_by_theme") {
                sideBarFilterByBtn = filterDrawer.querySelector(`button[data-collapsible-id='filter-theme']`);
            } else {
                sideBarFilterByBtn = filterDrawer.querySelector(`button[data-collapsible-id='filter-product-type']`);
            }

            // Proceed only if sideBarFilterByBtn is defined
            if (sideBarFilterByBtn) {
                const sideBarSubFilterBtnsParent = sideBarFilterByBtn.nextElementSibling;
                const selectFilter = sideBarSubFilterBtnsParent.querySelector(`input[value='${filterName}']`);
                if (filterName === "View all") {
                    clickableBlocks.forEach(b => {
                        b.dataset.active = "false";
                        b.classList.remove("active");
                    });
                    this.dataset.active = true;
                }

                if (selectFilter) {
                    const allCheckboxes = document.querySelectorAll("input[type='checkbox']");
                    const checkbox = document.querySelector(`input[value='${filterName}']`);
                    if (isActive) {
                        // Do nothing for now
                    } else {
                        allCheckboxes.forEach(input => input.checked = false);
                        clickableBlocks.forEach(b => b.dataset.active = "false");
                        checkbox.checked = true;
                        applyFilterBtn?.click();
                        this.dataset.active = true;
                    }
                } else {
                    console.error("Selected input data is not found in the filter type");
                }
            } else {
                console.error("Sidebar filter button not found");
            }
        });

    });
    function initImageTitleSlider(sectionContainer) {
        if (!sectionContainer) return;

        const blocks = sectionContainer.querySelectorAll('.image-title-block');

        if (blocks.length >= 4) {

            $(sectionContainer).slick({
                slidesToShow: 6.3,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 4.3
                        }
                    }
                ]
            });
        }
    }
    initImageTitleSlider(document.querySelector('.image-title-section.shop_by_theme'));
    initImageTitleSlider(document.querySelector('.image-title-section.shop_by_style'));

    const intervalId = setInterval(() => {
        const clickableElements = document.querySelectorAll('.clickable-content');

        if (clickableElements.length) {
            removeActiveFilterOnTop();
            clearInterval(intervalId);
        }
    }, 300);

});
function setEqualHeight(selector) {
    const elements = document.querySelectorAll(selector);
    let maxHeight = 0;

    // Reset any existing height
    elements.forEach(el => el.style.height = 'auto');

    // Find max height
    elements.forEach(el => {
        const height = el.offsetHeight;
        if (height > maxHeight) {
            maxHeight = height;
        }
    });

    // Apply max height
    elements.forEach(el => el.style.height = maxHeight + 'px');
}
window.addEventListener('DOMContentLoaded', () => setEqualHeight('.filter-image-img'));
window.addEventListener('resize', () => setEqualHeight('.filter-image-img'));
window.addEventListener('DOMContentLoaded', () => setEqualHeight('.filter-title-h3'));
window.addEventListener('resize', () => setEqualHeight('.filter-title-h3'));